import { useRef } from 'react';

import { ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import Header from '../../common/Header/Header';
import {
  Page,
  TableWrapper,
} from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';

import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';
import { useDateRanges } from '../../services/dateRange/dateRange.service';
import { readOnlyLabelTableText } from '../../constants/GlobalTexts';

const DateRanges = () => {
  const gridRef = useRef<AgGridReact>(null);
  const { data, isError: dateRangesError } = useDateRanges();

  useFetchErrorToast([{ isError: dateRangesError, label: 'Error fetching date ranges', id: 'dateRangesFetchError' }]);

  /**
   * We need to specify timezone because otherwise it will assume local browser timezone
   * So CST (UTC -6) will result in an offset by one day
   * @param {ValueFormatterParams} params
   */
  const dateRangeValueFormatter = (params: ValueFormatterParams): string => {
    const newDate = new Date(params.value);
    return newDate.toLocaleDateString('en-US', { timeZone: 'UTC' });
  };

  /**
   * Filter will work with the presented data
   * @param {ValueGetterParams} params
   * @returns {string}
   */
  const dateRangeFilterValueGetter = (params: ValueGetterParams): string => {
    const newDate = new Date(params.getValue(params.column.getColId()));
    return newDate.toLocaleDateString('en-US', { timeZone: 'UTC' });
  };

  return (
    <>
      <Header breadcrumb={{ to: '/tables', label: 'All tables' }} title="Date Range"
              titleTestId={'DateRangePageTitle'} />
      <Page>
        <TableWrapper>
          <Table
            rowData={data?.data}
            ref={gridRef}
            returnedRecords={data?.data?.length}
            height={'100%'}
            readOnlyLabel={readOnlyLabelTableText}
            columnDefs={[
              { minWidth: 112, field: 'dateRangeNo', headerName: 'Date Range No.' },
              { minWidth: 80, field: 'statusNo', headerName: 'Status No.' },
              { minWidth: 160, field: 'description', headerName: 'Description' },
              {
                minWidth: 80,
                field: 'fromDate',
                headerName: 'From Date',
                valueFormatter: dateRangeValueFormatter,
                filterValueGetter: dateRangeFilterValueGetter,
              },
              {
                minWidth: 80,
                field: 'toDate',
                headerName: 'To Date',
                valueFormatter: dateRangeValueFormatter,
                filterValueGetter: dateRangeFilterValueGetter,
              },
            ]}
          />
        </TableWrapper>
      </Page>
    </>
  );
};

export default DateRanges;
